<template>
  <label class="input-layout" v-bind:for="title">
    <span class="input-layout__label">{{ title }}</span>
    <slot />
  </label>
</template>
<script>
/**
 * @description Раскладка поля ввода.
 * @type {Vue}
 */
export default {
  name: 'InputLayout',
  props: {
    title: {
      required: true,
      type: String,
    },
  },
};
</script>
<style scoped>
.input-layout {
  display: flex;
  flex-direction: column;
}
.input-layout .input-layout__label {
  color: var(--unfocus-color);
  font-size: .75rem;
  font-weight: 400;
  line-height: 1rem;
}
</style>
